import { axios } from '@/utils/request'

const api = {
  youhuiquanOptions: '/badminapi/guafenquan/youhuiquanOptions',
  guafenDetail: '/badminapi/guafenquan/guafenquanDetail',
  guafenList: '/badminapi/guafenquan/guafenquanList',
  guafenEdit: '/badminapi/guafenquan/guafenquanEdit',
  guafenAdd: '/badminapi/guafenquan/guafenquanAdd',
  guafenDelete: '/badminapi/guafenquan/guafenquanDelete',
  setGuafenAllStatus: '/badminapi/guafenquan/setGuafenquanAllStatus',
  guafenOrderList: '/badminapi/guafenquan/orderList',
}

export default api

export function getGuafenList(parameter) {
  return axios({
    url: api.guafenList,
    method: 'get',
    params: parameter
  })
}
export function getGuafenDetail(parameter) {
  return axios({
    url: api.guafenDetail,
    method: 'get',
    params: parameter
  })
}
export function getYouhuiquanOptions(parameter) {
  return axios({
    url: api.youhuiquanOptions,
    method: 'get',
    params: parameter
  })
}
export function editGuafen(parameter) {
  return axios({
    url: api.guafenEdit,
    method: 'post',
    data: parameter
  })
}
export function addGuafen(parameter) {
  console.log('addGuafen');
  console.log(parameter);
  return axios({
    url: api.guafenAdd,
    method: 'post',
    data: parameter
  })
}

export function deleteGuafen(parameter) {
  return axios({
    url: api.guafenDelete,
    method: 'post',
    data: parameter
  })
}


export function setGuafenAllStatus(parameter) {
  return axios({
    url: api.setGuafenAllStatus,
    method: 'post',
    data: parameter
  })
}
export function getGuafenUserList(parameter) {
  return axios({
    url: api.guafenOrderList,
    method: 'post',
    data: parameter
  })
}